import { Stack } from '@mui/material'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { CardText } from '../subComponents/cardText'

interface FlightAirportsProps {
    origin?: string
    destination?: string
    originTerminal?: string
    destinationTerminal?: string
}

export const FlightAirports = ({
    origin,
    destination,
    originTerminal,
    destinationTerminal,
}: FlightAirportsProps) => {
    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack gap={'4px'}>
                <CardText
                    lineHeight={'21px'}
                    maxWidth={'180px'}
                    variant="bodySubtext"
                >
                    {origin}
                </CardText>
                {originTerminal && (
                    <CardText variant="bodySubtext">
                        {' '}
                        {`${cardTranslation('Terminal')} ${originTerminal}`}
                    </CardText>
                )}
            </Stack>
            <Stack gap={'4px'}>
                <CardText
                    lineHeight={'21px'}
                    textAlign={'end'}
                    maxWidth={'180px'}
                    variant="bodySubtext"
                >
                    {destination}
                </CardText>
                {destinationTerminal && (
                    <CardText textAlign={'end'} variant="bodySubtext">
                        {`${cardTranslation(
                            'Terminal'
                        )} ${destinationTerminal}`}
                    </CardText>
                )}
            </Stack>
        </Stack>
    )
}
